"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.UPDATE_PRESENCE_DELAY = exports.SUBSCRIPTION_DELAY = exports.PRESENCE_UPDATE = exports.PREMATURE_EXPIRATION_SUBSCRIPTION_TIME = exports.GROUNDSKEEPER_INTERVAL = exports.FETCH_DELAY = exports.EXPIRED_PRESENCE_TIME = exports.ENVELOPE_TYPE = exports.DEFAULT_SUBSCRIPTION_TTL = exports.APHELEIA_SUBSCRIPTION_UPDATE = void 0;
var GROUNDSKEEPER_INTERVAL = 20 * 1000; // 20 seconds in ms

exports.GROUNDSKEEPER_INTERVAL = GROUNDSKEEPER_INTERVAL;
var FETCH_DELAY = 300; // ms

exports.FETCH_DELAY = FETCH_DELAY;
var UPDATE_PRESENCE_DELAY = 60 * 1000; // 1 minute in ms

exports.UPDATE_PRESENCE_DELAY = UPDATE_PRESENCE_DELAY;
var EXPIRED_PRESENCE_TIME = 10 * 60 * 1000; // 10 minutes in ms

exports.EXPIRED_PRESENCE_TIME = EXPIRED_PRESENCE_TIME;
var SUBSCRIPTION_DELAY = 60 * 1000; // 1 minute in ms

exports.SUBSCRIPTION_DELAY = SUBSCRIPTION_DELAY;
var PREMATURE_EXPIRATION_SUBSCRIPTION_TIME = 60 * 1000; // 1 minute in ms

exports.PREMATURE_EXPIRATION_SUBSCRIPTION_TIME = PREMATURE_EXPIRATION_SUBSCRIPTION_TIME;
var DEFAULT_SUBSCRIPTION_TTL = 10 * 60 * 1000; // 10 minutes in ms

exports.DEFAULT_SUBSCRIPTION_TTL = DEFAULT_SUBSCRIPTION_TTL;
var APHELEIA_SUBSCRIPTION_UPDATE = 'event:apheleia.subscription_update';
exports.APHELEIA_SUBSCRIPTION_UPDATE = APHELEIA_SUBSCRIPTION_UPDATE;
var PRESENCE_UPDATE = 'updated';
exports.PRESENCE_UPDATE = PRESENCE_UPDATE;
var ENVELOPE_TYPE = {
  SUBSCRIPTION: 'subscription',
  PRESENCE: 'presence',
  DELETE: 'delete'
};
exports.ENVELOPE_TYPE = ENVELOPE_TYPE;
//# sourceMappingURL=constants.js.map
